import axios from '@/utils/request'
// import { setToken } from '../libs/util';
// 获取扫码登陆接口
export const getCode = (params)=>{
  return axios.request({
     url: '/v1/code',
     method: 'get',
     params
   })
 };
export const sendLogin = (data)=>{
 return axios.request({
    url: '/v1/login',
    method: 'post',
    data
  })
};
export const sendLogout = (data)=>{
  return axios.request({
    url: '/v1/loginOut',
    method: 'post',
    data
  })
};
export const sendUserInfo = (params)=>{ 
return axios.request({
  url: 'v1/user/overView',
  method: 'get',
  params
})
}

//忘记密码
export const sendForget = (params)=>{ 
  // let token = localStorage.getItem('token');
return axios.request({
  url: '/v1/forget',
  method: 'get',
  params
})
}
//获取验证码
export const retrievePasswordCode = (params)=>{ 
return axios.request({
  url: '/v1/retrievePasswordCode',
  method: 'get',
  params
})
}

//验证校验
export const postCodeCheck = (params)=>{ 
  return axios.request({
    url: '/v1/codeCheck',
    method: 'post',
    params
  })
  }

  //重置密码
export const postReset = (params)=>{ 
  return axios.request({
    url: '/v1/reset',
    method: 'post',
    params
  })
  }

